export default __webpack_public_path__ + "static/media/nine.8036728e.ogg";